const postUrl = {
	addCategory: '/category',
	addProduct: '/product',
	weightConvertor: '/product/weightConvertor',
	addBrand: '/brand',
	saveAllBrands: '/brand/saveAll',

	createEnquiry: '/enquiry',
	createDuplicateEnquiry: '/enquiry/createDuplicateEnquiry',
	addEnquiryItem: '/enquiry/enquiry-item',
	downloadEstimate: '/enquiry/generateEstimatePdf',
	convertToOrder: '/enquiry/convertToOrder',
	updateEnquiryCostMetrics: '/enquiry/updateCostMetrics',
	addSiteManager: 'enquiry/addSiteManager',
	createOrder: '/order/createOrderFromEnquiry',
	createUser: '/user',
	createLedger: '/ledger',
	createCollection: '/payment-receivables',
	uploadBulkUsers: '/user/uploadUserCSV',
	updateUserFCM: '/user/updateFcm',

	getUserByPhone: '/login/getByPhone',
	setUserClaim: 'login/setUserClaim',
	setUserName: '/login/setUserName',
	setRegisteredGst: '/login/setRegisteredGst',
	enterPanDetails: '/login/enterPanDetails',

	addSupplierToOrder: '/order/addSupplierToOrder',
	addBuyerToOrder: '/order/addBuyerToOrder',
	addOrderSiteManager: 'order/addSiteManager',

	uploadBuyerPO: '/files/uploadBuyerPo',
	uploadBuyerPoList: '/files/uploadBuyerPoList',
	uploadSupplierPoList: '/files/uploadSupplierPoList',
	uploadBuyerInvoice: '/files/uploadBuyerInvoice',
	uploadBuyerReceivedTc: '/files/uploadBuyerReceivedTc',
	uploadBuyerBilty: '/files/uploadBuyerBilty',
	uploadBuyerDKT: '/files/uploadBuyerDkt',
	uploadBuyerUpdatedTC: '/files/uploadBuyerUpdatedTc',
	uploadBuyerEwayBill: '/files/uploadBuyerEwayBill',
	uploadBuyerDeliveryReceipt: '/files/uploadBuyerDeliveryReceipt',

	uploadSupplierPO: '/files/uploadSupplierPo',
	uploadSupplierInvoice: '/files/uploadSupplierInvoice',
	uploadSupplierReceivedTc: '/files/uploadSupplierReceivedTc',
	uploadSupplierBilty: '/files/uploadSupplierBilty',
	uploadSupplierDKT: '/files/uploadSupplierDkt',
	uploadSupplierEwayBill: '/files/uploadSupplierEwayBill',
	uploadSupplierProductPhotos: '/files/uploadSupplierProductPhotos',
	uploadInvoiceDocument: '/files/uploadInvoiceDocument',

	uploadAuctionReceivedTc: '/files/uploadAuctionReceivedTc',
	uploadAuctionStockPhoto: '/files/uploadAuctionStockPhoto',

	uploadDocWithType: '/files/uploadDocument',
	uploadInterestPaymentDocuments: '/files/uploadInterestPaymentDocuments',

	createAuction: '/auction',
	createOrderFromAuction: '/order/createOrderFromAuction',

	createLogistics: '/logistics/createLogisticsRequests',

	convertToOrderLogisticsRequest: '/logistics/createOrderFromLogisticsRequest',

	uploadLogisticsInvoice: '/logistics/uploadLogisticsInvoice',

	uploadDispatchWeighmentSlip: '/logistics/uploadDispatchWeighmentSlip',
	uploadDropWeighmentSlip: '/logistics/uploadDropWeighmentSlip',
	uploadLorryReceipt: '/logistics/uploadLorryReceipt',
	uploadMaterialReceivingDoc: '/logistics/uploadMaterialReceivingDoc',
	shareEnquiry: '/enquiry/shareEnquiry',

	createMachine: '/machine',
	createFactory: '/factory',

	uploadUserBusinessPhotos: '/files/uploadUserBusinessPhotos',
	uploadFactoryPhoto: '/files/uploadFactoryPhoto',
	uploadFactoryMachinePhoto: '/files/uploadFactoryMachinePhoto',
	uploadMachineTemplatePhoto: '/files/uploadMachineTemplatePhoto',
	createFabricationOrder: '/factory/createFabricationOrder',
	uploadFabricationInvoice: '/files/uploadFabricationInvoice',
	uploadFabricationJourneyPhotos: '/files/uploadFabricationJourneyPhotos',
	uploadFactoryReceivingPhoto: '/files/uploadFactoryReceivingPhoto',
	uploadFactoryMbReceivingPhoto: '/files/uploadFactoryMbReceivingPhoto',
	uploadTestCertificate: '/files/uploadTestCertificate',
	uploadBuyerInvoiceDocuments: '/files/uploadBuyerInvoiceDocuments',
	uploadSupplierInvoiceDocuments: '/files/uploadSupplierInvoiceDocuments',

	toolsEndorseInvoice: '/tools/endorseInvoice',
	toolsEndorseTestCertificate: '/tools/endorseTestCertificate',
	logisticsPrices: '/logisticsPrices',
	createLogisticsQuote: '/logistics',

	createUserInteraction: '/userInteraction',
	closeUserInteraction: '/userInteraction/markAsClosed',
	updateOffer: '/userInteraction/updateOffer',

	addInvoice: '/invoice',
	createInvoicePayment: '/invoice-payment',
	toolsCalculateDistance: '/tools/calculateDistance',
	toolsReconciliationProcess: '/tools/reconciliationProcess',
	uploadDashboardHtmlReport: '/tools/uploadDashBoardHtmlFiles',

	createCreditReport: '/financials/report',
	downloadCreditReport: '/financials/report/downloadCreditReport',
	updateSalesTeamFeedback: '/financials/report/updateSalesTeamFeedback',
	updateTenorAmount: '/financials/report/updateTenorAmount',
	fetchPastRecords: '/financials/report/fetchPastRecords',
	markAsCompleted: '/financials/report/markAsCompleted',
	uploadProcessFile: '/financials/report/uploadProcessFile',
	initiateGenerateReport: '/financials/report/initiateGenerateReport',
	uploadFsaReport: '/financials/report/uploadFsaReport',
	updateTeamFeedback: 'financials/report/updateTeamFeedback',

	fetchInvoices: '/zoho/fetchInvoices',
	fetchLogisticsBill: '/zoho/fetchBills',

	addTrip: '/order/trip',
	closeTrip: '/order/closeTrip',
	triggerPodMessage: 'order/triggerPodMessage',

	generateAadhaarOTP: '/financials/kyc/generateAadhaarOtp',
	verifyAadhaarOTP: '/financials/kyc/verifyAadhaarOTP',
	uploadKYCDocument: '/financials/kyc/addDocument',
	verifyPan: '/financials/kyc/panVerification',
	commodity: '/commodity',
	addCommodityPriceList: '/commodity-price/addList',

	requestCredit: '/requestCredit/requestCredit',
	uploadFinancialDocs: '/requestCredit/uploadFinancialDocs',
	refreshZohoPastRecords: '/zoho/refreshPastRecordOfUser',
	createBanner: '/banner/create',

	createOrganisation: '/organisation/createOrganisation',
	addUser: '/organisation/addUser',
	addRemarks: '/organisation/addRemarks',
	activateCommodity: '/organisation/activateCommodity',
	activateUserCommodity: '/user/activateCommodity',
	addUserCommodity: '/organisation/addCommodity',
	updateReportingManager: '/user/updateReportingManager',
	addSalesAdmin: '/organisation/addSalesAdmin',
	addRelationshipManagers: '/organisation/addRelationshipManagers',

	createContent: '/content/createContent',
	contentUploadFile: 'content/uploadFile',
	uploadMagazinePdf: 'content/uploadMagazinePdf',

	uploadCran: '/financials/uploadCran',
	addPdc: '/financials/addPdc',
	uploadOrgFinancialDocument: '/financials/uploadDocument',

	createLead: '/lead',
	addTaskReminder: '/lead/addTaskReminder',

	createPunchOrder: '/punchOrder',
	uploadPunchOrderFile: '/punchOrder/uploadFile',

	createCreditLimit: '/creditLimit',
	uploadCreditLimitDocument: '/creditLimit/uploadFile',
	uploadPdcChequeImage: '/financials/uploadChequeImage',

	createGlossary: '/glossary',

	createSupplierOrder: 'supplierOrder',
	createSpoFromOrder: 'supplierOrder/createSpoFromOrder',
	addSpoItem: 'supplierOrder/item',

	migrateOrganisationsToOracle: '/oracle/migrateOrganisationsToOracle',
	createDispatchPlan: '/dispatchPlan',
	uploadVehicleDocuments: '/dispatchPlan/uploadVehicleDocuments',
	bookInvoice: '/dispatchPlan/bookInvoice',

	createShipmentRequest: '/shipmentRequest',
	createShipmentRequestSupplyResponse: '/shipmentRequest/supplyResponse',
	createShipmentDispatchPlans: '/shipmentRequest/dispatchPlan',
	autoCreateShipment: '/shipmentRequest/autoCreateShipment',

	addCranComment: '/cranReport/addComment',
	saveInspectionReport: '/cranReport/saveInspectionReport',
	generateCranReport: '/cranReport/generateCranReport',
	generateProbeReport: '/cranReport/generateProbeReport',
	addVotingDocument: '/cranReport/votingDocument',
	uploadCranCommentDocument: '/cranReport/uploadCranCommentDocument',

	submitReceivingAcknowledgement: '/extra/submitReceivingAcknowledgement',

	tenderbook: '/tenderBook',

	modeOrderFilesWithinS3: '/reports/backupInvoicesToS3',

	sendApprovalMessage: 'creditApproval/approval/message',
	uploadApprovalDocument: 'creditApproval/approval/document/upload',
}

export default postUrl
